import { useState } from "react";
import { Link } from "react-router-dom";
import { Layout } from "../../components/Layout";
import { useCart } from "../../providers/cart";
import {
  ART_LIST_URL,
  ART_URL,
  CHECKOUT_URL,
  USER_AUTH_URL,
} from "../../config";
import { Button, BUTTON_COLORS, BUTTON_TYPE } from "../../components/Button";
import { Price } from "../../components/Price";
import { ArtList } from "../../components/ArtList";
import { usePermissions } from "../../providers/authProvider";
import { UNDERLINE_CLASS } from "../../utils";

export type CreateLocationData = {};

export default function Cart() {
  const { cart, removeItem, resetCart } = useCart();
  const permissions = usePermissions();
  return (
    <Layout headerStyle="sm">
      <div className="px-7">
        <h2 className="text-textMain text-4xl">Your cart</h2>
        <div className="flex flex-wrap items-start justify-around 2xl:justify-between gap-7">
          <div className="py-7">
            <ArtList
              justify=""
              items={cart.items}
              getArtConfig={(art) => ({
                href: ART_URL(art.slug),
                showPrice: "below",
                text: <>{art.title}</>,

                actionCorner: {
                  onAction: () => removeItem(art),
                  actionIcon: <div className="text-4xl">🗑️</div>,
                  actionTitle: "Remove from cart",
                  actionSize: "4rem",
                  actionColor: "warning",
                  actionCorner: "bottomRight",
                },
              })}
            />
          </div>
          <div className="flex items-center justify-around flex-col gap-4 w-full 2xl:w-auto max-w-[500px] px-2">
            {cart.items.length ? (
              <>
                <Link
                  className={
                    BUTTON_TYPE.large +
                    BUTTON_COLORS.primary +
                    "text-center m-0 !w-full"
                  }
                  to={
                    permissions?.data?.user?.id
                      ? CHECKOUT_URL()
                      : USER_AUTH_URL("login", { flow: "checkout" })
                  }
                >
                  Checkout for{" "}
                  <Price
                    item={{
                      price: cart.items.reduce(
                        (count, item) => count + (item.price ?? 0),
                        0
                      ),
                      currency: cart.items[0].currency,
                    }}
                  />{" "}
                  + tax
                </Link>

                <Button
                  btnColor="warning"
                  btnType="large"
                  className={" text-center m-0 !w-full "}
                  onClick={resetCart}
                >
                  Empty cart
                </Button>

                <Link to={ART_LIST_URL()} className={UNDERLINE_CLASS + " p-2 "}>
                  Or keep shopping!
                </Link>
              </>
            ) : (
              <Link
                to={ART_LIST_URL()}
                className={BUTTON_TYPE.small + BUTTON_COLORS.primary}
                style={{
                  textTransform: "capitalize",
                  margin: 10,
                }}
              >
                Get to Looking!
              </Link>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}
